export default __webpack_public_path__ + "static/media/send-black.c798a1de.svg";